module.exports = __webpack_public_path__ + "media/images/badges/Android_icon-0348d06a97668ec1d411f2c2fd2d9bb7.svg";